import React from 'react';
import './style.scss';
import noDesktopQrCodeImage from '../../../images/no-desktop-qr-code.png';

export const NoDesktop = () => {
  return <div className="app-no-desktop">
    <div className="app-no-desktop--text">Открой игру<br/> с мобильного</div>
    <img src={noDesktopQrCodeImage} alt="" className="app-no-desktop--image"/>
  </div>;
}